<template>
  <div class="main-wrap">
    <h1>
      <i class="far fa-check" style="color: var(--app-color-primary) "></i>
    </h1>
    <h1>Your order was completed successfully.</h1>
    <div class="row justify-content-md-center">
      <div class="col-md-7 text-align-center">
        <div class="icon-wrap"><i class="fas fa-mailbox"></i></div>
      </div>
      <div class="col-md-7">
        <div class="email_wrap text-align-center">
          <h1>
            An email receipt including the details about your order has been
            sent to the email <strong> {{ order.emailToConfirm }}</strong
            >. Please keep it for your record.
          </h1>
        </div>
      </div>
    </div>
    <div class="row justify-content-md-center text-align-center">
      <div
        class="col-md-7 reciprocity"
        v-if="profile[0].reciprocity || profile[0].reciprocity === 1"
      >
        ** You have selected Reciprocity **
      </div>

      <div
        class="col-md-7 reciprocity paylater"
        v-if="order.selPaymentMethod === 3"
      >
        <span v-html="order.payLaterText"></span>
      </div>
      <div class="col-md-7 reciprocity " style="text-align: right">
        <md-button
          @click="printMe('print')"
          class="btn-green"
          style="margin: 0"
        >
          Print</md-button
        >
      </div>
      <div class="col-md-7 order-details">
        <p
          class="trans-head"
          style="background: var(--app-color-primary) ; color: white; background-color: var(--app-color-primary) "
        >
          Order #: {{ order.tranID }}
          <span class="order-time">{{ transactionDate }}</span>
        </p>
      </div>
      <div class="order-items col-md-7">
        <div class="table">
          <table>
            <thead>
              <tr>
                <th>Qty</th>
                <th class="text-left">Description</th>
                <th class="text-left">Cost</th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="cart.list.length">
                <td>{{ cart.list.length }}</td>
                <td class="text-left">{{ $gift_word }} to Members</td>

                <!-- <td class="text-left">Greetings to Members</td> -->
                <td class="text-left">
                  {{ order.membersPrice | currency(settings[0].symbol) }}
                </td>
              </tr>
              <tr v-if="cart.additionalBaskets.length">
                <td>{{ cart.additionalBaskets.length }}</td>
                <td class="text-left">Gift Baskets to be Shipped</td>
                <td class="text-left">
                  {{ order.basketPrice | currency(settings[0].symbol) }}
                </td>
              </tr>

              <tr v-for="item in cart.orderItems" :key="item.orderItemId">
                <td>{{ item.quantity }}</td>
                <td class="text-left">{{ item.description }}</td>
                <td
                  class="text-left"
                  v-if="
                    item.itemId !== 1 &&
                      item.itemId !== 29 &&
                      item.itemId !== 30
                  "
                >
                  {{
                    (item.price * item.quantity) | currency(settings[0].symbol)
                  }}
                </td>
                <td
                  class="text-left"
                  v-if="
                    item.itemId == 1 || item.itemId == 29 || item.itemId == 30
                  "
                >
                  {{
                    (item.price * item.quantity) | currency(settings[0].symbol)
                  }}
                </td>
              </tr>
              <tr v-if="!discounts.length">
                <td class="text-left total p-l-2" colspan="2">Order Total</td>
                <td class="text-left total">
                  {{ order.totalPrice | currency(settings[0].symbol) }}
                </td>
              </tr>
              <tr v-if="discounts.length">
                <td class="text-left p-l-2 disc" colspan="2">Total</td>
                <td class="text-left disc">
                  {{ order.totalPrice | currency(settings[0].symbol) }}
                </td>
              </tr>
              <tr v-if="discounts.length">
                <td class="text-left p-l-2 disc" colspan="2">
                  {{ discounts[0].description }}
                </td>
                <td class="text-left disc disc-t">
                  -{{ order.disc | currency(settings[0].symbol) }}
                </td>
              </tr>
              <tr v-if="discounts.length">
                <td class="text-left total p-l-2" colspan="2">Order Total</td>
                <td class="text-left total">
                  {{
                    order.totalDiscountedPrice | currency(settings[0].symbol)
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="order-d-header">Order Details</p>
        <div class="table table_compact" v-if="cart.list.length">
          <p class="text-left p-details">
            Members List ({{ cart.list.length }})
          </p>
          <table style="table-layout: fixed">
            <tbody>
              <tr v-for="(item, index) in cart.list" :key="item.UserID">
                <td class="text-left">
                  {{ index + 1 }}. {{ item.lastName }} {{ item.firstName
                  }}<span v-if="item.sFirstName">
                    & {{ item.sFirstName }}
                    <span v-if="item.sLastName !== item.lastName">{{
                      item.sLastName
                    }}</span></span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- shipping baskets outside members -->
        <div class="table table_compact" v-if="cart.additionalBaskets.length">
          <p class="text-left p-details">
            Gift Baskets to be Shipped ({{ cart.additionalBaskets.length }})
          </p>
          <table style="table-layout: fixed">
            <tbody>
              <tr
                v-for="item in cart.additionalBaskets"
                :key="item.shippingItemId"
              >
                <td class="text-left">{{ item.recipient }}</td>
                <td class="text-left">Message: {{ item.message }}</td>
                <td class="text-left">
                  Address: {{ item.address }} {{ item.address2 }},{{
                    item.city
                  }}, {{ item.state }} {{ item.zip }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- ************** -->
    <!-- only for print -->
    <!-- ************** -->
    <div id="print" style="visibility: hidden">
      <h1 style="text-align: center">
        <i class="far fa-check" style="color: var(--app-color-primary) "></i>
      </h1>
      <h1 style="text-align: center; color: var(--app-color-primary) ">
        Your order was completed successfully.
      </h1>
      <div class="row justify-content-md-center">
        <div class="text-align-center">
          <div class="icon-wrap">
            <i
              class="fas fa-mailbox"
              style="color: var(--app-color-primary) ; font-size: 25px"
            ></i>
          </div>
        </div>
        <div class="">
          <div class="email_wrap text-align-center" style="text-align: center">
            <h1 style="font-size: 25px; color: var(--app-color-primary) ">
              An email receipt including the details about your order has been
              sent to the email <strong> {{ order.emailToConfirm }}</strong
              >. Please keep it for your record.
            </h1>
          </div>
        </div>
      </div>
      <div
        class="row justify-content-md-center text-align-center"
        style="text-align: center; width: 100%; font-size: 18px"
      >
        <div
          class="reciprocity"
          v-if="profile[0].reciprocity || profile[0].reciprocity === 1"
        >
          ** You have selected Reciprocity **
        </div>
        <div class=" reciprocity paylater" v-if="order.selPaymentMethod === 3">
          <span v-html="order.payLaterText"></span>
        </div>
        <div class="reciprocity" style="text-align: right">
          <!-- <md-button @click="printMe('print')" class="btn-green" style="margin:0"> Print</md-button> -->
        </div>
        <div
          class="col-xs-12 order-details"
          style="width: 90%; margin: 0 auto; text-align: left"
        >
          <p
            class="trans-head"
            style="
              background: var(--app-color-primary) ;
              color: white;
              background-color: var(--app-color-primary) ;
              padding: 10px;
            "
          >
            Order #: {{ order.tranID }}
            <span class="order-time">{{ transactionDate }}</span>
          </p>
        </div>
        <div class="order-items" style="width: 90%; margin: 0 auto">
          <div class="table" style="width: 90%; margin: 0 auto">
            <table style="width: 100%">
              <thead>
                <tr>
                  <th>Qty</th>
                  <th class="text-left">Description</th>
                  <th class="text-left">Cost</th>
                </tr>
              </thead>

              <tbody>
                <tr v-if="cart.list.length">
                  <td>{{ cart.list.length }}</td>
                  <td class="text-left">{{ $gift_word }} to Members</td>
                  <td class="text-left">
                    {{ order.membersPrice | currency(settings[0].symbol) }}
                  </td>
                </tr>
                <tr v-if="cart.additionalBaskets.length">
                  <td>{{ cart.additionalBaskets.length }}</td>
                  <td class="text-left">Gift Baskets to be Shipped</td>
                  <td class="text-left">
                    {{ order.basketPrice | currency(settings[0].symbol) }}
                  </td>
                </tr>

                <tr v-for="item in cart.orderItems" :key="item.orderItemId">
                  <td>{{ item.quantity }}</td>
                  <td class="text-left">{{ item.description }}</td>
                  <td
                    class="text-left"
                    v-if="
                      item.itemId !== 1 &&
                        item.itemId !== 29 &&
                        item.itemId !== 30
                    "
                  >
                    {{
                      (item.price * item.quantity)
                        | currency(settings[0].symbol)
                    }}
                  </td>
                  <td
                    class="text-left"
                    v-if="
                      item.itemId == 1 || item.itemId == 29 || item.itemId == 30
                    "
                  >
                    {{
                      (item.price * item.quantity)
                        | currency(settings[0].symbol)
                    }}
                  </td>
                </tr>
                <tr v-if="!discounts.length">
                  <td class="text-left total p-l-2" colspan="2">Order Total</td>
                  <td class="text-left total">
                    {{ order.totalPrice | currency(settings[0].symbol) }}
                  </td>
                </tr>
                <tr v-if="discounts.length">
                  <td class="text-left p-l-2 disc" colspan="2">Total</td>
                  <td class="text-left disc">
                    {{ order.totalPrice | currency(settings[0].symbol) }}
                  </td>
                </tr>
                <tr v-if="discounts.length">
                  <td class="text-left p-l-2 disc" colspan="2">
                    {{ discounts[0].description }}
                  </td>
                  <td class="text-left disc disc-t">
                    -{{ order.disc | currency(settings[0].symbol) }}
                  </td>
                </tr>
                <tr v-if="discounts.length">
                  <td class="text-left total p-l-2" colspan="2">Order Total</td>
                  <td class="text-left total">
                    {{
                      order.totalDiscountedPrice | currency(settings[0].symbol)
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p
            class="order-d-header"
            style="
              background: var(--app-color-primary) ;
              color: white;
              background-color: var(--app-color-primary) ;
              padding: 10px;
            "
          >
            Order Details
          </p>
          <div
            class="table table_compact"
            v-if="cart.list.length"
            style="width: 90%; margin: 0 auto"
          >
            <p class="text-left p-details">
              Members List ({{ cart.list.length }})
            </p>
            <table style="table-layout: fixed; width: 100%">
              <tbody>
                <tr v-for="item in list" :key="item.UserID">
                  <td class="text-left">
                    {{ item.title }} {{ item.lastName }} {{ item.firstName }}
                    {{ item.sFirstName }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- shipping baskets outside members -->
          <div
            class="table table_compact"
            v-if="cart.additionalBaskets.length"
            style="width: 90%; margin: 0 auto"
          >
            <p
              class="text-left p-details"
              style="
                background: var(--app-color-primary) ;
                color: white;
                background-color: var(--app-color-primary) ;
                padding: 10px;
              "
            >
              Gift Baskets to be Shipped ({{ cart.additionalBaskets.length }})
            </p>
            <table style="table-layout: fixed">
              <tbody>
                <tr
                  v-for="item in cart.additionalBaskets"
                  :key="item.shippingItemId"
                >
                  <td class="text-left">{{ item.recipient }}</td>
                  <td class="text-left">Message: {{ item.message }}</td>
                  <td class="text-left">
                    Address: {{ item.address }} {{ item.address2 }},{{
                      item.city
                    }}, {{ item.state }} {{ item.zip }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import currencyFilter from "../shared/currency-filter";
import VueHtmlToPaper from "vue-html-to-paper";
import $ from "jquery";

export default {
  name: "ConfirmPage",
  filters: {
    currency: currencyFilter,
  },
  data: function() {
    return {
      list: [],
      cart: {},
      order: {},
      transactionID: "",
      transactionDate: moment().format("MM/DD/YYYY hh:mm A"),
      globalOptions: {
        name: "_blank",
        specs: [
          // 'fullscreen=no',
          // 'titlebar=yes',
          // 'scrollbars=yes'
        ],
        styles: [
          "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
          "https://pro.fontawesome.com/releases/v5.10.0/css/all.css",
          "../assets/css/bundle.css",
          "https://demo.happypurim.app/#/assets/css/print.css",
        ],
      },
    };
  },
  computed: {
    settings() {
      return this.$store.state.settings;
    },
    discounts() {
      return this.$store.state.discounts;
    },
    profile() {
      return this.$store.state.userProfile;
    },
  },
  methods: {
    printMe: function(id) {
      this.$htmlToPaper(id, this.globalOptions, () => {
        console.warn("done landscape");
      });
    },
  },
  created() {
    window.scrollTo(0, 0);
    let list = this.$store.state.list;
    for (var i = 0; i < list.length; i++) {
      if (!list[i].paid && list[i].selected) {
        this.list.push(list[i]);
      }
    }
    for (let i in this.$store.state.cart) {
      this.cart[i] = this.$store.state.cart[i];
    }
    for (let i in this.$store.state.finalOrder) {
      this.order[i] = this.$store.state.finalOrder[i];
    }

    setTimeout(() => this.$store.commit("resetCart", this.list), 1000);
  },
};
</script>
<style scoped>
.main-wrap {
  padding: 3em 2em;
}
.fa-check {
  font-size: 4em;
  color: var(--app-color-primary);
}
h1 {
  color: var(--app-color-primary);
  font-weight: 600;
  text-align: center;
}
.order-time {
  float: right;
  font-size: 0.8em;
}
.table {
  border: 1px solid #f1f0f0;
}
.text-align-center {
  text-align: center;
}
.disc {
  background: #f1f0f0;
  font-weight: 600;
}
.disc-t {
  color: #4bbe56;
}
.p-details {
  padding: 0.5em 1em;
  border-bottom: 1px solid #dfdfdf;
  margin-bottom: 0;
  font-weight: 600;
  background: #f1f0f0;
}
.trans-head {
  margin: 2em 0 0;
  padding: 1em;
  text-align: left;
  background: var(--app-color-primary);
  color: #fff;
  font-size: 1.2em;
  font-weight: 500;
}
.order-d-header {
  font-size: 1.5em;
  font-weight: 600;
  margin-top: 2em;
  padding-bottom: 1em;
  border-bottom: 3px solid var(--app-color-primary);
}
.table_compact td {
  padding: 0.25rem 0.75rem;
  font-size: 0.8em;
}
.total {
  background: var(--app-color-primary);
  color: #fff;
  font-size: 1.2em;
  font-weight: 600;
}
.email-wrap {
  display: inline-block;
  width: 70%;
}
.icon-wrap {
  font-size: 50px;
  padding: 10px;
  color: var(--app-color-primary);
}
.email_wrap h1 {
  font-size: 21px;
}
.reciprocity {
  padding: 1em 1em 0;
  font-size: 18px;
  font-weight: 600;
}

.table_compact td {
  padding: 0.25rem 0.75rem;
  font-size: 0.8em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.paylater {
  padding: 1em;
  border: 2px solid var(--app-color-primary);
  margin-top: 1em;
}
</style>
